import { Component } from '@angular/core';

@Component({
  selector: 'app-invite',
  templateUrl: './invite.component.html',
  styleUrls: ['./invite.component.scss'],
})
/**
 * Template that renders Business Representative Invitation page
 */
export class InviteComponent {}
